<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/woprocedure/pageWithQueryParams"
        getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_cross_select multiple :component="'web_base_equipment_list'"
                :ids.sync="yt.conditions.equipmentIds">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_cross_select multiple :component="'web_base_matter_list'"
                :ids.sync="yt.conditions.materialIds">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('gongdanzhuangtai')">
            <yi_dictionary_select :max="8" multiple :type="'PRODUCTION_WO_STATUS'" :ids.sync="yt.conditions.woStatusList">
            </yi_dictionary_select>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary"
                plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear({woStatusList: ['3'],orderBy: 'createTime desc'})">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('dianjianxiang', scope.row,'70%')">
              {{$t('dianjianxiang')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="scope.row.status==1" type="text" class="font-color-danger"
                @click="yt.remove(scope.row,'/web/equipment/check/bill/delete')">{{$t('shanchu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
        :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 点检项 -->
      <template v-if="yt.editObj.action == 'dianjianxiang'">
        <div class="dialog-scroller">
          <check_item :equipment="yt.editObj" ref="checkItem"></check_item>
        </div>

        <span slot="footer" class="dialog-footer">
					<el-button v-if="!(yt.editObj.status == 3 || yt.editObj.status == 2)" size="mini"
              @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button v-if="!(yt.editObj.status == 3 || yt.editObj.status == 2)" size="mini"
              @click="submitCheckItem(yt.editObj)" type="primary">
						{{$t('tijiao')}}
					</el-button>
				</span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_quality_management_work_order',
  data() {
    return {
      exceptionTypeList: [],
      planIdList: '',
      columns: [
      //     {
      //   label: 'xuanze',
      //   type: 'selection',
      // },
        {
        label: 'shengchangongdanhao',
        prop: 'wo.no',
        width: 180,
      }, {
        label: 'ERPgongdanhao',
        prop: 'wo.erpNo',
        width: 130,
      },

        {
          label: 'gongdanzhuangtai',
          type: 'tag',
          prop: 'wo.status',
          tags: {
            1: {
              color: '#419FFF',
              text: this.$t('xinjian')
            },
            2: {
              color: '#419FFF',
              text: this.$t('fafang')
            },
            3: {
              color: '#67C23A',
              text: this.$t('shengchanzhong')
            },
            4: {
              color: '#F56C6C',
              text: this.$t('zanting')
            },
            5: {
              color: '#67C23A',
              text: this.$t('shougongxuwangong')
            },
            6: {
              color: '#67C23A',
              text: this.$t('wangong')
            },
            7: {
              color: '#909399',
              text: this.$t('guanbi')
            },
            8: {
              color: '#E6A23C',
              text: this.$t('yidiaobo')
            }
          },
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          width: 130,
        },
        {
          label: 'mujubianhao',
          prop: 'mould.no',
          width: 130,
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          width: 130,
        }, {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          width: 130,
        },
        {
          label: 'gongxubianma',
          prop: 'procedureCode',
          width: 130,
        },
        {
          label: 'gongxumiaoshu',
          prop: 'procedureDesc',
          width: 130,
        },
        {
          label: 'jihuashuliang',
          prop: 'planQuantity',
        },
        {
          label: 'baogongshuliang',
          prop: 'reportQuantity',
          width: 130,
        },
        {
          label: 'yibaogongliangpinshu',
          prop: 'finishGoodQuantity',
          width: 130,
        },

        {
          label: 'yibaogongbuliangpinshu',
          prop: 'finishBadQuantity',
          width: 130,
        },
        {
          label: 'shengyushengchanshuliang',
          prop: 'leftProductionQuantity',
          width: 130,
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        woStatusList: ['2','3','4','5'],
        orderBy: 'createTime desc',
      }
      this.yt.SELECT_URL = "/web/production/woprocedure/listByIds"
      this.yt.SELECT_RESULT_KEY = "data"
      this.yt.SELECT_ID = "id"
      this.yt.SELECT_TITLE = "no"
      this.yt.get(1);
      this.getExceptionType()
    }, 300)
  },

  methods: {
    // beforeGet(params) {
    //   params['orderBy'] = 'createTime desc'
    //   params['woStatusList'] = 3
    //   return params
    // },
    selectionChange(items) {
      this.planIdList = items.map(item => {
        return item.id
      })
      this.planId = items.map(item => {
        return item.no
      }).join(',')
    },
    submitCheckItem(value) {
      this.http.post('web/equipment/check/bill/commit', {
        id: value.id,
        remark: value.remark,
        itemList: this.$refs.checkItem.$refs.yt.list
      }).then(res => {
        this.yt.isShowEditDialog = false
        this.yt.get(1)
      });
    },
    getExceptionType() {
      this.http.get('/web/andon/exceptionType/page', {
        params: {
          pageNum: 1,
          pageSize: 1000
        }
      }).then(res => {
        this.exceptionTypeList = res.data.rows
      })

    }
  }
};
</script>
